import React from 'react'
import { Box, Container, Grid, Typography } from '@material-ui/core'
import { useStyles } from './SingleSlider.style'
import EndIconButton from '../EndIconButton'
import RichText from '../RichText'
import { replaceBucketUrl } from '../../utils/cms'

const baseURL = `/assets/`

const SingleSlider = ({ sliderData, buttonIcon }) => {
  const styles = useStyles()

  if (!sliderData) return null

  const {
    slideHeading = '',
    slideDescription,
    sliderCta,
    sliderImage,
  } = sliderData

  let descriptionContent = null
  if (slideDescription && slideDescription.raw) {
    try {
      descriptionContent = JSON.parse(slideDescription.raw)
    } catch (error) {
      descriptionContent = null
    }
  }

  const imageUrl =
    sliderImage && sliderImage.bucketUrl
      ? replaceBucketUrl(sliderImage.bucketUrl)
      : '/default-placeholder.png' // TODO: use placeholder

  return (
    <Box textAlign="-webkit-center">
      <Container maxWidth="lg" className={styles.singleSliderContainer}>
        <Grid container className={styles.gridContainer}>
          <Grid
            item
            md={6}
            xs={12}
            className={styles.singleSliderSectionWrapper}
          >
            {slideHeading && (
              <Typography variant="h3" className={styles.singleSliderHeader}>
                {slideHeading}
              </Typography>
            )}
            {descriptionContent && (
              <RichText
                document={descriptionContent}
                variant="body1"
                className={styles.singleSliderDescription}
              />
            )}
            {sliderCta && sliderCta.link && (
              <EndIconButton
                isExternal={sliderCta.isExternal}
                {...(sliderCta.isExternal
                  ? { href: `${baseURL}${sliderCta.link}` }
                  : { link: `${sliderCta.link}` })}
                className={styles.sliderCta}
                title={sliderCta.title || 'Learn More'}
                icon={buttonIcon}
              />
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <Box
              style={{
                backgroundImage: `url(${imageUrl})`,
              }}
              className={styles.singleSliderImage}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default SingleSlider
